import { debounce } from '../../../_common/client/debounce';
import { getSessionStorage } from '../../../_common/client/session-storage';

const HORIZONTAL_SCROLL_POSITION_PREFIX_FOR_SESSION_STORAGE_KEY = 'ft5-dimension-horizontal-scroll-position';

export function storeScrollPositionAfterScrolling(scrollableTileContainer: HTMLElement, storageKey: string) {
    const sessionStorage = getSessionStorage();
    scrollableTileContainer.addEventListener(
        'scroll',
        debounce(() => {
            sessionStorage.setItem(buildKeyForSessionStorage(storageKey), `${scrollableTileContainer.scrollLeft}`);
        }, 30)
    );
}

export function restoreScrollPosition(scrollableTileContainer: HTMLElement, storageKey: string) {
    const sessionStorage = getSessionStorage();
    const scrollToValueFromSessionStorage = sessionStorage.getItem(buildKeyForSessionStorage(storageKey));
    if (scrollToValueFromSessionStorage) {
        const parsedScrollPosition = parseInt(scrollToValueFromSessionStorage, 10);
        scrollableTileContainer.scrollTo({ left: parsedScrollPosition });
    }
}

function buildKeyForSessionStorage(storageKey: string) {
    return `${HORIZONTAL_SCROLL_POSITION_PREFIX_FOR_SESSION_STORAGE_KEY}-${storageKey}`;
}
